import { NextSeo } from "next-seo";
import { useEffect } from "react";

import MainNavbar from "components/Navbar/MainNavbar";
import GetStarted from "./GetStarted";
import Footer from "./Footer";

import * as Track from "@qoohoo/common/utils/analytics/track";
import { getOGImageType } from "@qoohoo/common/utils/url";
import { convertAssetPathToLink } from "@qoohoo/common/utils/url";
import { pageview } from "@qoohoo/common/constants/analytics";

const ProductPageLayout = ({
  seo,
  children,
  footerWavePath,
  theme
}) => {
  const currentScreen = pageview[seo.title];

  useEffect(() => {
    Track.pageView(currentScreen);
  }, []);

  let ogImageUrl;

  if (seo?.ogImageAsset) {
    ogImageUrl = convertAssetPathToLink(seo.ogImageAsset);
  }

  const nonSecureOGImageUrl = ogImageUrl?.replace("https://", "http://");

  return (
    <div className="font-nunito" style={{ backgroundColor: theme.backgroundColor, color: theme.textColor }}>
      <NextSeo
        title={seo?.title || "Qoohoo"}
        description={seo?.description || "Qoohoo"}
        openGraph={{
          title: seo?.title || "Qoohoo",
          url: seo?.url,
          description: seo?.description || "Qoohoo",
          images: ogImageUrl
            ? [
                {
                  url: nonSecureOGImageUrl,
                  secureUrl: ogImageUrl,
                  alt: seo.title || "Qoohoo",
                  type: getOGImageType(ogImageUrl),
                  height: 640,
                  width: 640,
                },
              ]
            : [],
        }}
      />
      <MainNavbar isDark={theme.isDark} currentScreen={currentScreen} showAuth />
      <div>
        {children}
      </div>
      <GetStarted theme={theme}/>
      <Footer
        theme={theme}
        footerWavePath={footerWavePath}
      />
    </div>
  );
};

export default ProductPageLayout;
